import React, { useState } from 'react';

const OfferCalculator = ({ listingPrice = 2800000 }) => {
  const [adjustments, setAdjustments] = useState({
    marketCondition: 0,
    daysOnMarket: 15,
    propertyCondition: 0,
    urgency: 0,
  });

  const totalAdj = Object.values(adjustments)?.reduce((a, b) => a + b, 0);
  const baseMin = listingPrice * 0.93;
  const baseMax = listingPrice * 0.98;
  const adjMin = Math.round((baseMin * (1 + totalAdj / 100)) / 1000) * 1000;
  const adjMax = Math.round((baseMax * (1 + totalAdj / 100)) / 1000) * 1000;
  const midpoint = Math.round((adjMin + adjMax) / 2 / 1000) * 1000;

  const fmt = (n) => `$${(n / 1000000)?.toFixed(3)?.replace(/\.?0+$/, '')}M`;

  const sliders = [
    { key: 'marketCondition', label: 'Market Conditions', min: -10, max: 5, step: 1, desc: "Buyer's market (-) vs Seller's market (+)" },
    { key: 'daysOnMarket', label: 'Days on Market Discount', min: 0, max: 20, step: 1, desc: 'Longer listing = more negotiating power' },
    { key: 'propertyCondition', label: 'Property Condition', min: -8, max: 3, step: 1, desc: 'Poor condition (-) vs Excellent (+)' },
    { key: 'urgency', label: 'Your Urgency', min: -5, max: 0, step: 1, desc: 'High urgency reduces negotiating room' },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-2">Offer Calculator</h3>
      <p className="text-sm text-muted-foreground mb-6">Adjust parameters to calculate your optimal offer range.</p>
      <div className="bg-gradient-to-br from-primary/10 to-accent/5 rounded-xl p-5 mb-6 border border-primary/20">
        <p className="text-sm text-muted-foreground mb-1">Recommended Offer Range</p>
        <div className="flex items-end gap-3 mb-2">
          <span className="text-3xl font-bold" style={{ color: '#00D4FF' }}>{fmt(adjMin)}</span>
          <span className="text-muted-foreground mb-1">—</span>
          <span className="text-3xl font-bold" style={{ color: '#00FF88' }}>{fmt(adjMax)}</span>
        </div>
        <p className="text-sm text-muted-foreground">Midpoint: <span className="font-semibold text-foreground">{fmt(midpoint)}</span> · Listing: <span className="font-semibold text-foreground">{fmt(listingPrice)}</span></p>
      </div>
      <div className="space-y-5">
        {sliders?.map(s => (
          <div key={s?.key}>
            <div className="flex justify-between items-center mb-1">
              <label className="text-sm font-medium text-foreground">{s?.label}</label>
              <span className="text-sm font-bold" style={{ color: adjustments?.[s?.key] >= 0 ? '#00FF88' : '#FF6666' }}>
                {adjustments?.[s?.key] >= 0 ? '+' : ''}{adjustments?.[s?.key]}%
              </span>
            </div>
            <input type="range" min={s?.min} max={s?.max} step={s?.step} value={adjustments?.[s?.key]} onChange={e => setAdjustments(prev => ({ ...prev, [s?.key]: Number(e?.target?.value) }))} className="w-full h-2 rounded-full appearance-none cursor-pointer" style={{ accentColor: '#00D4FF' }} />
            <p className="text-xs text-muted-foreground mt-1">{s?.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OfferCalculator;
